import { motion } from "framer-motion";
import { ArrowRight, CalendarDays } from "lucide-react";
import { useDemoModal } from "@/context/DemoModalContext";

const fade = {
  initial: { opacity: 0, y: 14 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.75 },
};

export default function CTASection() {
  const { openFreeModal } = useDemoModal();
  return (
    <section
      id="cta"
      data-testid="cta-section"
      className="py-20 md:py-32"
    >
      <div className="mx-3 sm:mx-4 md:mx-8">
        <div
          className="relative overflow-hidden rounded-[1.75rem] px-5 py-16 sm:rounded-[2.5rem] sm:px-6 md:px-12 md:py-20 lg:py-28"
          style={{
            background: "linear-gradient(165deg, #1A1135 0%, #2E2458 48%, #1F1838 100%)",
          }}
        >
          <div
            aria-hidden="true"
            className="pointer-events-none absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-transparent via-gold/80 to-transparent"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-60"
            style={{
              background:
                "radial-gradient(ellipse 70% 50% at 25% 10%, rgba(201,162,39,0.12) 0%, transparent 50%)",
            }}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 opacity-40"
            style={{
              background:
                "radial-gradient(ellipse 50% 60% at 80% 90%, rgba(74,58,138,0.25) 0%, transparent 55%)",
            }}
          />

          <div className="relative flex flex-col items-center text-center">
            <motion.h2
              {...fade}
              data-testid="cta-title"
              className="font-display max-w-2xl text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight leading-[1.08]"
            >
              Lo construimos porque lo vivimos.
            </motion.h2>

            <motion.p
              {...fade}
              className="mt-6 max-w-lg text-xl md:text-2xl text-white/55 leading-relaxed"
            >
              Sabemos lo que necesitas: una herramienta simple, en español, que te devuelva tiempo para las personas. Empieza gratis, sin tarjeta, en minutos.
            </motion.p>

            <motion.div
              {...fade}
              className="mt-10 flex flex-col sm:flex-row items-center gap-4"
            >
              <button
                type="button"
                onClick={openFreeModal}
                data-testid="cta-primary-button"
                className="inline-flex h-[52px] items-center justify-center gap-2 rounded-xl px-8 text-[17px] font-bold text-ink shadow-[0_8px_32px_-8px_rgba(0,0,0,0.4)] transition-all duration-300 hover:brightness-110 hover:-translate-y-0.5"
                style={{
                  background: "linear-gradient(180deg, #E8D78A 0%, #C9A227 100%)",
                }}
              >
                Empezar gratis
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="#pricing"
                data-testid="cta-secondary-button"
                className="inline-flex h-[52px] items-center justify-center rounded-xl border border-white/20 bg-white/[0.06] px-8 text-[17px] font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/[0.12]"
              >
                Ver planes
              </a>
              <button
                type="button"
                data-cal-link="ekklesiaonline-demo"
                data-cal-config='{"layout":"month_view"}'
                data-testid="cta-agenda-button"
                className="inline-flex h-[52px] items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/[0.06] px-8 text-[17px] font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/[0.12]"
              >
                <CalendarDays className="h-5 w-5" />
                Agenda una llamada
              </button>
            </motion.div>

            <motion.p
              {...fade}
              className="mt-8 text-base text-white/35"
            >
              Sin tarjeta &middot; Sin compromiso &middot; Acceso en segundos
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
}
